export default __webpack_public_path__ + "static/media/warning--offset-roads--g4.353ab25e.png";